import React from "react";
import { Col, Container, Row } from "reactstrap";

import DaemonPage from "./Details";

import { withTranslation } from "react-i18next";

const DaemonDetailsPage = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Row>
            <Col lg="12">
              <DaemonPage />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(DaemonDetailsPage);
